import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetTeamTimelineResponse,
  PostTeamTimelineResponse,
  GetTeamTimelineByIdResponse,
  PutTeamTimelineResponse,
} from '../response/team-timeline';

export class TeamTimelineService {
  static getTeamTimeline(params?: QueryParams) {
    return apiClient.get<GetTeamTimelineResponse>(buildApiUrl('/api/v1/team/team-timeline'), params);
  }

  static postTeamTimeline(data: any) {
    return apiClient.post<PostTeamTimelineResponse>(buildApiUrl('/api/v1/team/team-timeline'), data);
  }

  static getTeamTimelineById(id: string) {
    return apiClient.get<GetTeamTimelineByIdResponse>(buildApiUrl('/api/v1/team/team-timeline/:id', { id }), undefined);
  }

  static putTeamTimeline(id: string, data: any) {
    return apiClient.update<PutTeamTimelineResponse>(buildApiUrl('/api/v1/team/team-timeline/:id', { id }), data);
  }

  static deleteTeamTimeline(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/team/team-timeline/:id', { id }), undefined);
  }
}
